import DictionaryModel from "./DictionaryModel";

export default class AutomaticModerationModel {
  public enabled: boolean = false;
  public moderateLinks: boolean = false;
  public linksWhitelist: string[] = [];
  public moderatorProfileId: string = "";
  public dictionary: DictionaryModel = new DictionaryModel();
}
